import { FC, ReactElement, ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { Scroller } from '@ta-interaktiv/react-scroller'
import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import ExampleComponent from '../ExampleComponent'
import { useWindowSize } from 'usehooks-ts'
import { Annotation, annotationsspec } from './Annotations'
import { MapKey } from 'components/MapKey'
import { ContentByDay_de } from './ContentByDay_de'
import { annos, countries, firstarrows } from './annos'

const mobileimageswitch = 711

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const [windowHeight, setWindowHeight] = useState(0)
  const { width, height } = useWindowSize()
  const Content = ContentByDay_de
  useEffect(() => {
    setWindowHeight(window.innerHeight)
  }, [])

  useEffect(() => {
    setWindowHeight(height)
  }, [width])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <Scroller
        front={[
          <FrontElement>{Content['2022-02-23']}</FrontElement>,
          <FrontElement>{Content['2022-02-25']}</FrontElement>,
          <FrontElement>{Content['2022-03-02']}</FrontElement>,
          <FrontElement>{Content['2022-03-24']}</FrontElement>,
          <FrontElement>{Content['2022-03-05']}</FrontElement>,
          <FrontElement>{Content['2022-03-23']}</FrontElement>,
          <FrontElement>{Content['2022-04-06']}</FrontElement>,
          <FrontElement>{Content['2022-04-07']}</FrontElement>,
          <FrontElement>{Content['2022-04-14']}</FrontElement>,
          <FrontElement>{Content['2022-05-18']}</FrontElement>,
          <FrontElement>{Content['2022-05-30']}</FrontElement>,
          <FrontElement>{Content['2022-06-30']}</FrontElement>,
          <FrontElement>{Content['2022-07-04']}</FrontElement>,
          <FrontElement>{Content['2022-08-10']}</FrontElement>,
          <FrontElement>{Content['2022-08-31']}</FrontElement>,
          <FrontElement>{Content['2022-09-06']}</FrontElement>,
          <FrontElement>{Content['2022-09-12']}</FrontElement>,
          <FrontElement>{Content['2022-09-30']}</FrontElement>,
          <FrontElement>{Content['2022-10-08']}</FrontElement>,
          <FrontElement>{Content['2022-10-10']}</FrontElement>,
          <FrontElement>{Content['2022-11-15']}</FrontElement>,
          <FrontElement>{Content['2022-12-01']}</FrontElement>,
          <FrontElement>{Content['2023-01-02']}</FrontElement>,
          <FrontElement>{Content['2023-01-10']}</FrontElement>,
          <FrontElement>{Content['2023-01-20']}</FrontElement>,
          <FrontElement distanceBottom={1000}>
            {Content['2023-02-16']}
          </FrontElement>,
        ]}
        back={(index: number) => {
          const days = [
            '2022-02-23',
            '2022-02-25',
            '2022-03-02',
            '2022-03-24',
            '2022-03-05',
            '2022-03-23',
            '2022-04-06',
            '2022-04-07',
            '2022-04-14',
            '2022-05-18',
            '2022-05-30',
            '2022-06-30',
            '2022-07-04',
            '2022-08-10',
            '2022-08-31',
            '2022-09-06',
            '2022-09-12',
            '2022-09-30',
            '2022-10-08',
            '2022-10-10',
            '2022-11-15',
            '2022-12-01',
            '2023-01-02',
            '2023-01-10',
            '2023-01-20',
            '2023-02-16',
          ]
          if (index > days.length - 1) index = days.length - 1
          if (index < 0) index = 0

          const mapkeysAllways: MapKeyEntry[] = [
            {
              label_de: 'russische Vorstösse',
              label_fr: 'Avancées russes',
              color: '#E9999F_hatched',
            },
            {
              label_de: 'russisch kontrollierte Gebiete',
              label_fr: 'Territoires contrôlés par la Russie',
              color: '#E9999F',
            },
            {
              label_de: 'ukrainische Gegenoffensive',
              label_fr: "Offensive d'Ukraine",
              color: '#9BC6DE',
            },
          ]
          index > 8 &&
            mapkeysAllways.push({
              label_de: 'zurückeroberte Gebiete',
              label_fr: 'Territoires reprises',
              color: '#9BC6DE_hatched',
            })

          return (
            <LayoutWrapper windowHeight={windowHeight} key={'map_' + index}>
              <ImageHolder windowHeight={windowHeight}>
                <img
                  alt='Karte der Urkaine'
                  src={require('../../assets/maps/' +
                    days[index] +
                    (width < mobileimageswitch ? '-mob' : '') +
                    '.jpg')}
                />
                <PositionWrapper>
                  <DateDisplay>
                    {new Date(days[index]).toLocaleDateString('ch-DE', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                    })}
                  </DateDisplay>
                  <MapKey entries={[...mapkeysAllways]} />
                  {annos[days[index]].map((anno, i) => {
                    return (
                      <Annotation anno={anno} key={'anno' + index + '_' + i} />
                    )
                  })}
                  <Source>Quelle: ISW</Source>
                </PositionWrapper>
              </ImageHolder>
            </LayoutWrapper>
          )
        }}
      />
      <Chapter>
        Die Bilanz
        <span>
          Ein Drittel des eroberten Gebiets haben die Russen wieder verloren
        </span>
      </Chapter>
    </AppContainer>
  )
}

const Chapter = styled.h2`
  width: 100%;
  text-align: center;

  font-size: 50px;
  line-height: 1.2em;
  span {
    font-family: var(--font-plex);
    margin-top: 20px;
    font-weight: 300;
    display: inline-block;
    line-height: 1.4em;
    padding-left: 10%;
    padding-right: 10%;
    width: 80%;
    font-size: 22px !important;
  }
`

const I = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  background-color: var(--beige-bright-2);
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
`

const FrontElement = styled.div<{
  children: ReactNode
  [key: string]: string | ReactNode
}>`
  background-color: var(--site-background);
  color: var(--text-color);
  padding: 30px 30px;
  max-width: 666px;
  margin-left: 5vw;
  @media screen and (max-width: 711px) {
    margin-left: 0;
    max-width: calc(100vw - 4rem);
    padding: 30px 2rem;
  }

  /* img {
    margin-top: 30px;
    max-width: calc(100%);
    @media screen and (max-width: 711px) {
      max-width: calc(100% + 60px);
      margin-left: -30px;
    }
  } */
`

const Source = styled.div.attrs({ className: 'source' })`
  background-color: transparent;

  color: var(--text-color);
  padding: 10px;
  padding-right: 20px;
  padding-bottom: 12px;
  display: inline-block;
  position: absolute;
  right: 0%;
  bottom: 0;
  font-size: 12px;
  font-family: var(--font-plex);
  color: var(--gray-3);
  @media screen and (max-width: 711px) {
    font-size: 12px;
  }
`
const DateDisplay = styled.div`
  background-color: var(--site-background);

  color: var(--text-color);
  padding: 15px;
  display: inline-block;
  position: absolute;
  right: 0%;
  font-size: 15px;
  font-family: var(--font-plex);

  @media screen and (max-width: 711px) {
    font-size: 12px;
  }
`
const AppContainer = styled.div`
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--site-background);
`
export default MainComponent

// const Annotation = styled.div`
//   position: absolute;
//   top: 29%;
//   left: 45%;
//   font-family: var(--font-plex);
//   font-weight: 700;
// `

const ImageHolder = styled.div.attrs({ className: 'imageholder' })<{
  windowHeight: number
}>`
  line-height: 0;
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;

  img {
    height: ${(props) => props.windowHeight * 0.9}px;
    max-height: ${(props) => props.windowHeight * 0.975}px;
  }
`
const LayoutWrapper = styled.div<{ windowHeight: number }>`
  position: relative;
  display: inline-block;
  width: 100%;
  height: ${(props) => props.windowHeight}px;
  margin-top: ${(props) => props.windowHeight * 0.05}px;
  max-width: 100vw;
  overflow-x: hidden;
`
const PositionWrapper = styled.div`
  position: relative;
  height: 100%;
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
`
